import api from '@pray/shared/utils/api';

export async function createOffer({
  artistId = undefined,
  id = undefined,
  title = undefined,
  description = undefined,
  pdfUrl = undefined,
  coverImageUrl = undefined,
  thumbnailUrl = undefined,
  fileSize = undefined,
}) {
  const data = {
    artist_id: artistId,
    ...(id && { id }),
    title,
    description,
    ...(pdfUrl && { pdf_url: pdfUrl }),
    ...(coverImageUrl && { cover_image_url: coverImageUrl }),
    ...(thumbnailUrl && { thumbnail_url: thumbnailUrl }),
    ...(fileSize && { file_size: fileSize }),
  };

  const url = `/web/studio/offers`;
  const response = await api.executePostRequest(url, data);

  return response.data;
}
